// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2lINQ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3gumr"};